import React from 'react';
import { observer, inject } from 'mobx-react';
import Title from '@/components/Title';
import List from '@/components/List';
import styles from './AppFirmware.less';
import AddFirmware from '@/components/AppFirmware/AddFirmware';
import { Button } from 'antd/lib/radio';
import Loading from '../../components/Loading';

@inject('appFirmwareStore')
@observer
class AppFirmware extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appModal: false
    };
    this.showAppModal = this.showAppModal.bind(this);
    this.hideAppModal = this.hideAppModal.bind(this);
  }
  componentDidMount() {
    this.props.appFirmwareStore.loadFirmwareList();
  }
  showAppModal() {
    this.setState({
      appModal: true
    });
  }
  hideAppModal() {
    this.setState({
      appModal: false
    });
  }
  render() {
    return (
      <div className={styles.appFirmware}>
        <Title
          titleText={'固件列表'}
          btn={{
            text: '上传更新包',
            func: this.showAppModal,
            state: true
          }}
        />
        <div className={styles.listContainer}>
          {([...this.props.appFirmwareStore.firmwareListArr] || []).map(
            (item, index) => (
              <List
                key={index}
                BasicInfo={item}
                btnType={'firmwareBtn'}
                histroyList={['', '']}
                unfold={false}
              />
            )
          )}
        </div>
        <AddFirmware
          appModal={this.state.appModal}
          hideAppModal={this.hideAppModal}
        />
        <Loading />
      </div>
    );
  }
}
export default AppFirmware;



// WEBPACK FOOTER //
// ./src/pages/AppFirmware/AppFirmware.js